import { render, staticRenderFns } from "./UserAgents.vue?vue&type=template&id=c635c84a&"
import script from "./UserAgents.vue?vue&type=script&lang=js&"
export * from "./UserAgents.vue?vue&type=script&lang=js&"
import style0 from "./UserAgents.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports